import { useEffect, useState } from 'react';
import { FaGasPump, FaShieldAlt, FaChartLine } from 'react-icons/fa';
import { MdLocalGasStation } from 'react-icons/md';
import '../styles/SplashScreen.css';

const SplashScreen = () => {
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('Inicializando...');

  useEffect(() => {
    const messages = [
      'Carregando sistema...',
      'Conectando ao servidor...',
      'Validando credenciais...',
      'Preparando ambiente...',
      'Quase lá...'
    ];
    
    let progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 10;
      });
    }, 200);

    let messageInterval = setInterval(() => {
      setMessage(prev => {
        const currentIndex = messages.indexOf(prev);
        const nextIndex = (currentIndex + 1) % messages.length;
        return messages[nextIndex];
      });
    }, 800);

    return () => {
      clearInterval(progressInterval);
      clearInterval(messageInterval);
    };
  }, []);

  return (
    <div className="splash-screen-web">
      <div className="splash-card">
        {/* Logo */}
        <div className="splash-logo">
          <div className="logo-container">
            <div className="logo-ring"></div>
            <div className="logo-circle">
              <FaGasPump className="logo-icon-web" />
            </div>
          </div>
        </div>

        {/* Título */}
        <h1 className="splash-title-web">
          Guard<span>Visio</span>
        </h1>
        <p className="splash-subtitle-web">Sistema de Gestão de Posto</p>

        {/* Barra de progresso */}
        <div className="splash-progress-container">
          <div className="splash-progress-bar">
            <div 
              className="splash-progress-fill" 
              style={{ width: `${progress}%` }}
            >
              <div className="progress-glow"></div>
            </div>
          </div>
          <div className="splash-progress-text">
            <span className="progress-percentage">{progress}%</span>
            <span className="progress-message">{message}</span>
          </div>
        </div>

        {/* Features */}
        <div className="splash-features">
          <div className="feature-item">
            <FaChartLine />
            <span>Gestão de Abastecimentos</span>
          </div>
          <div className="feature-item">
            <FaShieldAlt />
            <span>Segurança e Confiabilidade</span>
          </div>
          <div className="feature-item">
            <MdLocalGasStation />
            <span>Controle de Frota</span>
          </div>
        </div>

        {/* Versão */}
        <div className="splash-version">
          <span>Versão 1.0.0</span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;